module.exports = __webpack_public_path__ + "img/dropsLive_1920.9b9604ae.png";